export const GET_OWNERS_CACHE_KEY = 'ownersCache';

export const cacheVariables = {
	[GET_OWNERS_CACHE_KEY]:{
		expiry: 8 * 60 * 60 * 1000, 
		useCache: true 
	}
}
